import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["href", "aria-label"]

import { GlobalLabels } from '@/shared/content/site-context.store';
import useGlobalLabels from '@/shared/content/useGlobalLabels';
import usePressMode from '@/shared/media/press-mode/usePressMode';


export default /*#__PURE__*/_defineComponent({
  __name: 'PressModeDownloadButton',
  props: {
    isProductImage: { type: Boolean },
    cacheBust: null,
    imageUrl: null
  },
  setup(__props: any) {




const globalLabels = useGlobalLabels(GlobalLabels.navigation);
const { isActive, getPressQualityImageUrl } = usePressMode();

return (_ctx: any,_cache: any) => {
  const _component_c_icon = _resolveComponent("c-icon")!

  return (_unref(isActive))
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        class: "download-button",
        href: _unref(getPressQualityImageUrl)(__props.imageUrl, __props.isProductImage, __props.cacheBust),
        "aria-label": _unref(globalLabels).pressModeDownload,
        target: "_blank"
      }, [
        _createVNode(_component_c_icon, {
          name: "icon-download",
          class: "h-x3 w-x3 c-icon--no-fill text-black"
        })
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})